import { render } from "./DirectIncome.vue?vue&type=template&id=17d4e060&scoped=true"
import script from "./DirectIncome.vue?vue&type=script&lang=js"
export * from "./DirectIncome.vue?vue&type=script&lang=js"

import "./DirectIncome.vue?vue&type=style&index=0&id=17d4e060&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d4e060"]])

export default __exports__